// 🔴 N°975 — « Créer le devis » depuis un RELEVÉ de chantier (Mario).
//
// 🔑 Le geste UTILISATEUR qui manquait (N°976 : le pont serveur existait, ⛔ aucun
//    bouton ne l'appelait). Il appelle LE pont existant
//    `POST /api/metier/mario/sessions/{releve_id}/devis` : valorisation par le
//    catalogue, blocage motivé si un prix manque, idempotence (un relevé = un devis).
//    ⛔ Aucune logique métier ici : on affiche ce que le serveur décide.
// ⚠️ FRONTIÈRE (N°877) : ce composant vit dans `metier/artisan/` (préfixe `/api/metier/`
//    autorisé). `chantier/ReleveChantier` ⛔ ne l'importe pas : il est INJECTÉ par
//    l'hôte (fiche dossier, visite mobile) via `actionsReleve`, ⛔ le relevé reste
//    limité à `/api/chantier/*`.
import { useState } from "react";
import { Encart } from "../../chantier/AnnexesReleve";
import { creerDevisDepuisReleve } from "./api";

const eur = (v) => (v == null ? "—" : `${Number(v).toLocaleString("fr-FR", { minimumFractionDigits: 2 })} €`);

const PRIMAIRE = { background: "var(--oh-accent-solid)", color: "var(--oh-accent-contrast)",
                   border: "none", borderRadius: 8, height: 36, padding: "0 12px", fontWeight: 500 };
const SECONDAIRE = { background: "transparent", color: "var(--oh-accent-text)",
                     border: "0.5px solid var(--oh-accent)", borderRadius: 8, height: 36, padding: "0 12px" };

/**
 * @param releve      le relevé affiché (au moins `id` et `postes`)
 * @param onOuvrir    (devis) => void — l'hôte décide comment OUVRIR le devis créé
 *                    (fiche : vue document ; mobile : PDF). Absent ⇒ pas de bouton d'ouverture.
 */
export function CreerDevisReleve({ releve, onOuvrir }) {
  const [devis, setDevis] = useState(null);
  const [erreur, setErreur] = useState("");
  const [envoi, setEnvoi] = useState(false);
  const nbPostes = (releve?.postes || []).length;

  if (!releve?.id) return null;
  if (!nbPostes) {
    return <Encart ton="info" testId="devis-releve-sans-poste">
      Ajoutez au moins un poste au relevé pour pouvoir créer le devis.
    </Encart>;
  }

  const creer = async () => {
    setErreur(""); setEnvoi(true);
    try { setDevis(await creerDevisDepuisReleve(releve.id)); }
    catch (e) { setErreur(e.message); }        // 409 motivé (prix manquant, relevé vide…) : on le DIT
    finally { setEnvoi(false); }
  };

  return (
    <section data-testid="devis-releve" style={{ display: "grid", gap: 8 }}>
      {!devis && (
        <button type="button" data-testid="creer-devis-releve" onClick={creer} disabled={envoi} style={PRIMAIRE}>
          {envoi ? "Création du devis…" : "Créer le devis"}
        </button>
      )}
      {devis && (
        <Encart ton="success" testId="devis-releve-cree">
          {devis.idempotent ? "Le devis de ce relevé existe déjà" : "Devis créé"}
          {devis.numero ? ` : ${devis.numero}` : ""} — {devis.lignes} ligne(s)
          {devis.total_ttc != null ? `, ${eur(devis.total_ttc)} TTC` : ""}.
        </Encart>
      )}
      {devis && onOuvrir && (
        <button type="button" data-testid="ouvrir-devis-releve" style={SECONDAIRE}
                onClick={async () => { setErreur(""); try { await onOuvrir(devis); } catch (e) { setErreur(e.message); } }}>
          Ouvrir le devis
        </button>
      )}
      {erreur && <Encart ton="error" testId="devis-releve-erreur">{erreur}</Encart>}
    </section>
  );
}

export default CreerDevisReleve;
